module.exports = __webpack_public_path__ + "media/images/placeholder/placeholder-08bb1445cbe890a87637df46202e5916.jpg";